import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("taskflow_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

/**
 * Safely extract a human-readable error string from any backend response.
 * Handles FastAPI/Pydantic 422 errors where `detail` is an array of
 * `{type, loc, msg, input, url}` objects, plus plain strings and unknowns.
 */
export const errMsg = (e, fallback = "Error") => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
        return d.map((x) => x?.msg || x?.message || JSON.stringify(x)).join("; ");
    }
    if (d && typeof d === "object") return d.msg || d.message || JSON.stringify(d);
    return e?.message || fallback;
};

export default api;
